import { render, staticRenderFns } from "./warehouseInfoTable.vue?vue&type=template&id=e45032a6&scoped=true&"
import script from "./warehouseInfoTable.vue?vue&type=script&lang=js&"
export * from "./warehouseInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./warehouseInfoTable.vue?vue&type=style&index=0&id=e45032a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45032a6",
  null
  
)

export default component.exports